export default "__VITE_ASSET__Cy638JYU__"